import React from 'react';
import { useUser } from 'store/models';

interface ICanProps{
  permission: string;
  children: React.ReactNode;
}

export default function Can({
  permission,
  children
}:ICanProps){
  const user = useUser();

  return (
    <React.Fragment>
      {user.hasPermission(permission)?children:<React.Fragment/>}
    </React.Fragment>
  );
}